import React, { useState } from 'react';
import { AddAppointment, Container1, Container2, BoxContainer, BoxInner1, InnerAppointments, Text, Texts, DataContainer, StatusData, LineContainer, MenuContainer, InnerBox, PagingContainer } from './Styles';
import { ReactComponent as Add } from '../../../../../../src/assets/images/add-square.svg';
import InputSelect from 'src/components/shared/Form/Select';
import { ReactComponent as MenuIcon } from '../../../../../assets/images/more.svg';
import Paging from 'src/components/App/Paging';
import { Chip, Box } from '@mui/material';
import theme from 'src/config/theme';
import NoDataFound from '../../NoDataFound/NoDataFound';
import FollowUpTabForm from '../Forms/FollowUpTabForm';
import DialogBox from 'src/components/shared/Dialog/DialogBox';


const FollowupCard = ({ followup = [], page, perPage, setPage, totalCount, fetchFollowUps }) => {
    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const data = followup.map((followupData) => ({
        followupId: followupData?.id,
        totalFollowup: followupData.totalFollowup,
        days: followupData.days,
        status: <Chip label="Task Assigned" sx={{
            background: 'linear-gradient(0deg, rgba(103, 57, 150, 0.14), rgba(103, 57, 150, 0.14))',
            color: theme.palette.action.purpleLight,
            ...theme.typography.small,
            borderRadius: '100px',
            padding: '10px 18px 8px 18px',
        }} />,
    }))
    return (
        <>
            <Container1>
                <AddAppointment
                    startIcon={<Add width="18px" height="18px" />}
                    onClick={handleOpen}
                >Add Followup</AddAppointment>


            </Container1>
            <Container2>
                <InnerAppointments>
                    <InnerBox isEmpty={data.length === 0}>
                        {data.length === 0 ? (
                            <NoDataFound
                                title="No Follow-ups Found!"
                                buttonText="Add FollowUp"
                                buttonIcon={Add}
                                onClick={handleOpen}
                            />
                        ) : (
                            <>    {data.map((item) => (
                                <BoxContainer key={item.followupId}>
                                    <BoxInner1>
                                        <DataContainer>
                                            <Text>{item.totalFollowup}</Text>
                                            <Texts>Total Follow-Up</Texts>
                                        </DataContainer>
                                        <StatusData>{item.status}</StatusData>
                                    </BoxInner1>
                                    <LineContainer />
                                    <BoxInner1>
                                        <DataContainer>
                                            <Text>{item.days}</Text>
                                            <Texts>Gap Between</Texts>
                                        </DataContainer>
                                        <MenuContainer>
                                            <MenuIcon />
                                        </MenuContainer>
                                    </BoxInner1>
                                </BoxContainer>
                            ))}
                            </>
                        )}

                    </InnerBox>
                    <PagingContainer>
                        <Paging
                            page={page}
                            perPage={perPage}
                            count={totalCount || 0}
                            onChange={(newPage) => setPage(newPage)}
                        />
                    </PagingContainer>
                </InnerAppointments>
                <DialogBox open={open} onClose={handleClose} >
                    <FollowUpTabForm onClose={handleClose} fetchFollowUps={fetchFollowUps} />
                </DialogBox>
            </Container2>
        </>
    )
}

export default FollowupCard
